// Desktop Carousel Functionality
document.addEventListener('DOMContentLoaded', function() {
    const desktopCarousel = document.getElementById('desktop-carousel');
    if (!desktopCarousel) return;

    const upBtn = document.getElementById('up-btn');
    const downBtn = document.getElementById('down-btn');
    const thumbnailsWrapper = document.getElementById('thumbnails-wrapper');
    
    let scrollPosition = 0;
    const scrollStep = 132;
    const maxScroll = 396;

    function updateCarouselButtons() {
        upBtn.disabled = scrollPosition <= 0;
        downBtn.disabled = scrollPosition >= maxScroll;
        
        upBtn.classList.toggle('disabled', scrollPosition <= 0);
        downBtn.classList.toggle('disabled', scrollPosition >= maxScroll);
    }

    function scrollUp() {
        scrollPosition = Math.max(0, scrollPosition - scrollStep);
        thumbnailsWrapper.style.transform = `translateY(-${scrollPosition}px)`;
        updateCarouselButtons();
    }

    function scrollDown() {
        scrollPosition = Math.min(maxScroll, scrollPosition + scrollStep);
        thumbnailsWrapper.style.transform = `translateY(-${scrollPosition}px)`;
        updateCarouselButtons();
    }

    upBtn.addEventListener('click', scrollUp);
    downBtn.addEventListener('click', scrollDown);
    
    updateCarouselButtons();
});

// Mobile Carousel Functionality
document.addEventListener('DOMContentLoaded', function() {
    const mobileCarousel = document.getElementById('mobile-carousel');
    if (!mobileCarousel) return;

    const leftBtn = document.getElementById('mobile-left-btn');
    const rightBtn = document.getElementById('mobile-right-btn');
    const mobileThumbnailsWrapper = document.getElementById('mobile-thumbnails-wrapper');
    
    let scrollPosition = 0;
    const scrollStep = 100;
    let maxScroll = 0;

    // Calculate the actual maximum scroll distance
    function calculateMaxScroll() {
        const wrapperWidth = mobileThumbnailsWrapper.scrollWidth;
        const containerWidth = mobileThumbnailsWrapper.parentElement.clientWidth;
        maxScroll = Math.max(0, wrapperWidth - containerWidth);
    }

    function updateMobileCarouselButtons() {
        leftBtn.disabled = scrollPosition <= 0;
        rightBtn.disabled = scrollPosition >= maxScroll;
        
        leftBtn.classList.toggle('disabled', scrollPosition <= 0);
        rightBtn.classList.toggle('disabled', scrollPosition >= maxScroll);
    }

    function scrollLeft() {
        if (scrollPosition > 0) {
            scrollPosition = Math.max(0, scrollPosition - scrollStep);
            mobileThumbnailsWrapper.style.transform = `translateX(-${scrollPosition}px)`;
            updateMobileCarouselButtons();
        }
    }

    function scrollRight() {
        if (scrollPosition < maxScroll) {
            scrollPosition = Math.min(maxScroll, scrollPosition + scrollStep);
            mobileThumbnailsWrapper.style.transform = `translateX(-${scrollPosition}px)`;
            updateMobileCarouselButtons();
        }
    }

    leftBtn.addEventListener('click', scrollLeft);
    rightBtn.addEventListener('click', scrollRight);
    
    // Smooth touch/swipe functionality for mobile carousel
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isDragging = false;
    let startPosition = 0;
    let currentPosition = 0;
    let isHorizontalSwipe = false;

    function handleTouchStart(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        startPosition = scrollPosition;
        isDragging = true;
        isHorizontalSwipe = false;
        mobileThumbnailsWrapper.style.transition = 'none';
    }

    function handleTouchMove(e) {
        if (!isDragging) return;
        
        const touchMoveX = e.touches[0].clientX;
        const touchMoveY = e.touches[0].clientY;
        const deltaX = Math.abs(touchStartX - touchMoveX);
        const deltaY = Math.abs(touchStartY - touchMoveY);
        
        // Determine if this is a horizontal swipe
        if (deltaX > 10 && deltaX > deltaY) {
            isHorizontalSwipe = true;
            e.preventDefault(); // Prevent page scroll
            e.stopPropagation();
        }
        
        if (isHorizontalSwipe) {
            touchEndX = touchMoveX;
            const deltaXMovement = touchStartX - touchEndX;
            currentPosition = Math.max(0, Math.min(maxScroll, startPosition + deltaXMovement));
            
            mobileThumbnailsWrapper.style.transform = `translateX(-${currentPosition}px)`;
        }
    }

    function handleTouchEnd(e) {
        if (!isDragging) return;
        
        isDragging = false;
        
        if (isHorizontalSwipe) {
            e.preventDefault();
            e.stopPropagation();
        scrollPosition = currentPosition;
            mobileThumbnailsWrapper.style.transition = 'transform 0.2s ease-out';
            updateMobileCarouselButtons();
        }
        
        isHorizontalSwipe = false;
    }

    // Add touch event listeners to the mobile thumbnails wrapper
    mobileThumbnailsWrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
    mobileThumbnailsWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
    mobileThumbnailsWrapper.addEventListener('touchend', handleTouchEnd, { passive: false });
    
    // Initialize the carousel
    calculateMaxScroll();
    updateMobileCarouselButtons();
    
    // Recalculate on window resize
    window.addEventListener('resize', () => {
        calculateMaxScroll();
        updateMobileCarouselButtons();
    });
});
